import React from "react";
import "../Components/Header.css";
import { Link } from "react-router-dom"; //Link
import banner1 from "../assets/images/banner1.png";
import banner4 from "../assets/images/banner4.png";
import banner5 from "../assets/images/banner5.jpg";
import banner6 from "../assets/images/banner6.jpg";

function Hero() {
  return (
    <div className="hero-outer">
      <div id="carouselExampleCaptions" className="carousel slide">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src={banner1} alt="Hero" />
            <div className="carousel-caption">
              <h1>Simple Textures. Beautiful Spaces.</h1>
                <Link to="/products">Browse Collection</Link>
            </div>
          </div>

           <div className="carousel-item">
            <img src={banner4} alt="Hero" />
            <div className="carousel-caption">
              <h1>Simple Textures. Beautiful Spaces.</h1>
               <Link to="/products">Browse Collection</Link>
            </div>
          </div>

            <div className="carousel-item">
            <img src={banner6} alt="Hero" />
            <div className="carousel-caption">
              <h1>Simple Textures. Beautiful Spaces.</h1>
               <Link to="/products">Browse Collection</Link>
            </div>
          </div>

           <div className="carousel-item">
            <img src={banner5} alt="Hero" />
            <div className="carousel-caption">
              <h1>Simple Textures. Beautiful Spaces.</h1>
               <Link to="/products">Browse Collection</Link>
            </div>
          </div>
         
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
}

export default Hero;
